enum SellerStatus {
    PENDING = "PENDING",
    INACTIVE = "INACTIVE",
    ACTIVE = "ACTIVE",
    REMOVED = "REMOVED"
}

export default SellerStatus;